import { Operator } from '@/modules/corporate/modules/database/fields/types';
import {
  getEmptyFieldValue,
  getFilterFieldValue,
} from '@/modules/corporate/modules/database/fields/utils/operators';
import { FilterOperatorEnum } from '@/types/schema';

const SelectOperators: Operator[] = [
  {
    labelKey: 'Database:Operators.Contains',
    value: FilterOperatorEnum.Contains,
    getFieldValue: getFilterFieldValue,
  },
  {
    labelKey: 'Database:Operators.ContainsNot',
    value: FilterOperatorEnum.ContainsNot,
    getFieldValue: getEmptyFieldValue,
  },
];

export default SelectOperators;
